// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vwOB","title":"styles_title__341Dh"};